export interface ICopyPricelistPayload {
  id_calendar: number
  id_object: number
  rooms: number[]
  targetDateFrom: string
  targetDateTo: string
  sourceDateFrom: string
  sourceDateTo: string
  increaseValue: number
  increaseUnit: 'percent' | 'currency'
  decreaseValue: number
  decreaseUnit: 'percent' | 'currency'
}

function toRoomsArray(rooms: number[] | Record<string, number>): number[] {
  if (Array.isArray(rooms)) return rooms.map(Number)
  if (rooms && typeof rooms === 'object') return Object.values(rooms).map(Number)
  return []
}

export default function(api: GlobalFetch) {
  return async function(payload: ICopyPricelistPayload): Promise<void> {
    const rooms = toRoomsArray(payload.rooms as number[] | Record<string, number>)
    const body = {
      id_calendar: payload.id_calendar,
      id_object: payload.id_object,
      rooms,
      targetDateFrom: payload.targetDateFrom,
      targetDateTo: payload.targetDateTo,
      sourceDateFrom: payload.sourceDateFrom,
      sourceDateTo: payload.sourceDateTo,
      increaseValue: payload.increaseValue,
      increaseUnit: payload.increaseUnit,
      decreaseValue: payload.decreaseValue,
      decreaseUnit: payload.decreaseUnit,
    }
    const response = await api.fetch('/api/v2/pricemulti/copy/', {
      method: 'POST',
      body: JSON.stringify(body),
    })
    if (!response.ok) {
      throw new Error(String(response.status))
    }
  }
}
